import { Select } from "antd";
import React from "react";

export const NotRenewingReasonPicker = React.forwardRef((props, ref) => {
	return (
		<Select style={{ minWidth: 120 }} {...props} ref={ref}>
			<Select.Option value="NO_LONGER_REQUIRED">
				No Longer Required
			</Select.Option>
			<Select.Option value="INSURED_ELSEWHERE">Insured Elsewhere</Select.Option>
			<Select.Option value="PRODUCT_UNSUITABLE">Not Suitable</Select.Option>
			<Select.Option value="TOO_EXPENSIVE">Too Expensive</Select.Option>
			<Select.Option value="CANCELLED_UNDER_COOLING_OFF_PERIOD">
				Cancelled in less than 14 days
			</Select.Option>
			<Select.Option value="CANCELLED_BY_UNDERWRITER">
				Underwriter Cancelled
			</Select.Option>
			<Select.Option value="SERVICE_ISSUES">Service Issues</Select.Option>
			<Select.Option value="OTHER">Other</Select.Option>
			<Select.Option value="NOT_KNOWN">Unknown</Select.Option>
		</Select>
	);
});

export const CancellationReasonPicker = React.forwardRef((props, ref) => {
	return (
		<Select style={{ minWidth: 120 }} {...props} ref={ref}>
			<Select.Option value="NO_LONGER_REQUIRED">No longer required</Select.Option>
			<Select.Option value="OTHER">Other</Select.Option>
		</Select>
	);
});
